import { Action, State } from './types'

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return action.payload
    default:
      return state
  }
}

export default reducer
